import { render, staticRenderFns } from "./ParticipantMenu.vue?vue&type=template&id=97eab752"
import script from "./ParticipantMenu.vue?vue&type=script&lang=js"
export * from "./ParticipantMenu.vue?vue&type=script&lang=js"
import style0 from "./ParticipantMenu.vue?vue&type=style&index=0&id=97eab752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports